/**
 * 角色删除
 */
import React from 'react';
import { Modal, Divider, message } from 'antd';
import PropTypes from 'prop-types';
import styles from './BtnSet.module.scss';
import { Radio, Form } from 'antd';

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};

class BtnSet extends React.Component {
    formRef = React.createRef();
    state = {
        title: this.props.title,
        btnData: this.props.data,
    };

    _handleOk = () => {
        const { btnData } = this.state;
        const btns = this._deepCopy(btnData.btns).map((item) => {
            if (item.readType == 'none') {
                item.readType = '';
                item.isChecked = '0';
            } else {
                item.isChecked = '1';
            }
            return item;
        });
        this.props.closeMode(true, 'btnset', { ...this.state.btnData, btns });
    }

    // 数组对象类型深度拷贝算法
    _deepCopy(obj) {
        if (typeof obj !== 'object') {
            return obj;
        }
        var res = Array.isArray(obj) ? [] : {};
        for (let i in obj) {
            if (i == 'component') {
                res[i] = obj[i];
            } else {
                res[i] = this._deepCopy(obj[i]);
            }
        }
        return res;
    }

    _handleCancel = () => {
        this.props.closeMode();
    }

    // 获取选项
    getChecked = (item) => {
        if (item.readType != '') {
            return item.readType;
        } else {
            return 'none';
        }
    }

    // 设置选项
    setChecked = (id, value) => {
        const { btnData } = this.state;
        const btns = btnData.btns.map((item) => {
            if (id == item.id) {
                item.readType = value;
            }
            return item;
        });
        this.setState({ btnData: { ...btnData, btns } });
    }

    // 设置全部选项
    setAllChecked = (value) => {
        const { btnData } = this.state;
        const btns = btnData.btns.map((item) => {
            item.readType = value;
            return item;
        });
        this.setState({ btnData: { ...btnData, btns } });
    }

    render() {
        const { confirmLoading, title, btnData } = this.state;

        return (
            <Modal
                width={900}
                centered
                title={title}
                visible={true}
                confirmLoading={confirmLoading}
                onOk={this._handleOk}
                onCancel={this._handleCancel}
                destroyOnClose={true}
                keyboard={true}
                maskClosable={false}
                cancelText='取消'
                okText='确认'
            >
                <div className={styles.container}>
                    <div className={styles.txt}>说明: 如果角色对当前对象设置了“新建”或“导入”权限，带*号的必填字段默认设置为“读写”，不可设置为“只读”或“不可见”，否则会造成新建/导入不成功</div>
                    <Form
                        {...formItemLayout}
                        ref={this.formRef}
                        initialValues={{}}
                        scrollToFirstError
                    >
                        <Form.Item
                            label="全选"
                            name="all"
                        >
                            <Radio.Group className={styles.radio} onChange={(e) => {
                                this.setAllChecked(e.target.value);
                            }}>
                                <Radio value={'READ_WRITE'}>读写</Radio>
                                <Radio value={'READ_ONLY'}>只读</Radio>
                                <Radio value={'none'}>不可见</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Divider />
                        {
                            btnData.btns && btnData.btns.map((item) => {
                                return (
                                    <Form.Item
                                        key={item.id}
                                        label={item.menuName}
                                    >
                                        <Radio.Group
                                            className={styles.radio}
                                            value={this.getChecked(item)}
                                            onChange={(e) => {
                                                this.setChecked(item.id, e.target.value);
                                            }}>
                                            <Radio value={'READ_WRITE'}>读写</Radio>
                                            <Radio value={'READ_ONLY'}>只读</Radio>
                                            <Radio value={'none'}>不可见</Radio>
                                        </Radio.Group>
                                    </Form.Item>

                                );
                            })
                        }
                    </Form>
                </div>
            </Modal>
        );

    }
}

BtnSet.propTypes = {
    data: PropTypes.object, // 弹框入参
    closeMode: PropTypes.func.isRequired, // 关闭弹框的回调函数
    title: PropTypes.string,// 弹框标题
};

export default BtnSet;